import { gql } from "@apollo/client"
import { executeQuerySideload } from "../../helpers/studyPlan"

const CHECK_STUDENT_ORG_POOL_LICENSE = gql`
  query checkOrgLicensePool($orgId: String!, $orgType: String!) {
    student {
      checkOrgLicensePool(orgId: $orgId, orgType: $orgType) {
        hasOrgLicensePool
      }
    }
  }
`

export async function checkStudentHasActiveOrgPoolLicense(
  _studentId: string, // Keep for backward compatibility but not used
  orgId: string,
  orgType: "DISTRICT" | "SCHOOL" = "DISTRICT"
): Promise<boolean> {
  try {
    const response = await executeQuerySideload(
      CHECK_STUDENT_ORG_POOL_LICENSE,
      { orgId, orgType }
    )

    const result = response?.student?.checkOrgLicensePool
    if (!result) return false

    // Return true if student has an active license pool in the specified organization
    return result.hasOrgLicensePool
  } catch (error) {
    console.error("Error checking student license pool:", error)
    return false
  }
}
